import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import AzureLoginButton from "./Components/AzureLoginButton";
import BasicLoginForm from "./Components/BasicLoginForm";

import { Card, Divider, Stack, Box } from "@mui/material";

export default function SignIn() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack
      direction={isSmallScreen ? "column" : "row"}
      sx={{ height: "100vh" }}
    >
      {/* LEFT SIDE (hidden on small screens) */}
      {!isSmallScreen && (
        <Box
          sx={{
            flex: 1,
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            px: 4,
          }}
        >
          <Box sx={{ maxWidth: 400, textAlign: "center" }}>
            <h2 style={{ fontWeight: 600, marginBottom: 16 }}>
              Disrupting Compliance for the Modern Enterprise
            </h2>
            <p>
              Easily manage communications, recorded interactions, and user
              access with full confidence in your compliance posture.
            </p>
          </Box>
        </Box>
      )}

      {/* RIGHT SIDE (logo + login form in a card) */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 4,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Card sx={{ width: "100%", maxWidth: 400, p: 4, backgroundColor: theme.palette.background.paper }}>
          <Stack spacing={3}>
            {/* Logo */}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img
                src={`${process.env.PUBLIC_URL}/disruptum-logo.png`}
                alt="Disruptum Logo"
                style={{
                  width: "120px",
                  maxHeight: "50px",
                  objectFit: "contain",
                }}
              />
            </Box>

            <BasicLoginForm />
            <Divider>or</Divider>
            <AzureLoginButton />
          </Stack>
        </Card>
      </Box>
    </Stack>
  );
}
